import React, {useState} from 'react';
import PurchaseOptionProduct from "./PurchaseOptionProduct";
import Button from "../../../components/Button";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import Spinner from "../../../components/Spinner";
import {PrepaidBagProduct, PrepaidBagProductService} from "../../../services/api/PrepaidBagProductService";
import ErrorBox from "../../onboarding/components/ErrorBox";
import {useApiRequest} from "../../../hooks/useApiRequest";

interface Props {

}

const PurchaseOptions = ({}: Props) => {

    const { prepaidBagProducts } = handicaddieSelector(state => state.clubs.selected)

    const [selectedProduct, setSelectedProduct] = useState<PrepaidBagProduct>()

    const { buyPrepaidBagProduct } = PrepaidBagProductService()

    const {execute: buy, loading, errMsg, setErrMsg} = useApiRequest(buyPrepaidBagProduct)

    const purchaseBag = async () => {
        if (!selectedProduct) {
            setErrMsg('Could not detect selected product. Please refresh and try again.')
            return;
        }
        buy(selectedProduct.id)
    }

    if (!prepaidBagProducts || prepaidBagProducts.length === 0) {
        return <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spinner onBackground />
            </div>
        </>
    }

    return (
        <>
            <div className={"purchaseOptions"}>
                {prepaidBagProducts
                    .map((product) => {
                        return <PurchaseOptionProduct
                            bagCount={product.quantity}
                            price={product.displayPrice}
                            selected={product.id === selectedProduct?.id}
                            discount={product.discount > 0 ? product.discount : undefined}
                            onClick={() => setSelectedProduct(product)} />
                })}
            </div>

            <div style={{ marginBottom: '5em' }}>
                <ErrorBox text={errMsg} />
                {!selectedProduct && <p>Please select a product above.</p>}
                {selectedProduct && <Button text={`${selectedProduct.displayPrice} BUY`} disabled={loading} onClick={purchaseBag} />}
            </div>
        </>
    )
}

export default PurchaseOptions;